import { useCourierTemplates } from '@commenda/api';
import { Badge } from '@commenda/kakashi';
import {
  SysEmailRecipientMode,
  TSysEmailStepDefinition,
} from '@commenda/types';
import { useWorkflow } from '../context/WorkflowContext';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const EmailNode = (props: TNodeProps) => {
  const { data } = props;
  const { workflow } = useWorkflow();
  const { data: templatesData } = useCourierTemplates();

  const step = workflow?.steps.find((s) => s.id === data.id) as
    | TSysEmailStepDefinition
    | undefined;
  const templateName = templatesData?.templates.find(
    (template) => template.id === step?.templateId
  )?.name;
  const recipientCount = step?.recipients?.length ?? 0;
  const recipientMode = step?.recipientMode ?? SysEmailRecipientMode.MANUAL;
  const needsSetup =
    !step?.templateId ||
    (recipientMode === SysEmailRecipientMode.MANUAL && recipientCount === 0);

  return (
    <BaseNode {...props}>
      {needsSetup ? (
        <Badge variant="warning" size="sm">
          Needs setup
        </Badge>
      ) : (
        <div className="flex flex-col gap-1">
          <span className="txt-extra-small-regular text-text-secondary truncate max-w-[180px]">
            {templateName ?? 'Template selected'}
          </span>
          <span className="txt-extra-small-regular text-text-secondary">
            {recipientMode === SysEmailRecipientMode.MATTER_THREAD
              ? 'To: matter thread'
              : `${recipientCount} recipient${recipientCount === 1 ? '' : 's'}`}
          </span>
        </div>
      )}
      <StandardHandles />
    </BaseNode>
  );
};

// DEMO ONLY - Do not use in production
export const DemoEmailNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props}>
      <StandardHandles />
    </BaseNode>
  );
};
